<div class="container mat-drawer-container login-background" fxLayout="row" fxLayoutAlign="center center">
  <div fxLayout="column" fxLayoutAlign="center start" id="login-section">
    <img src="./assets/images/logo_slogan_login.svg" style="margin-bottom: 2rem; width: 14rem" />
    
    <div fxLayout="row" fxLayoutAlign="center stretch">
      <div fxFlex.gt-xs="60" fxFlex.xs="100">
        <mat-card fxLayout="column" fxLayoutAlign="center center" style="height: 100%;">
          <form fxLayout="column" #loginForm="ngForm" (ngSubmit)="login(loginForm)">
            <p class="mat-h1">Login</p>
            <mat-form-field appearance="outline" class="login-input">
              <mat-label>Enter your email</mat-label>
              <input matInput type="email" id="username" required ngModel #username="ngModel" name="username" email />
            </mat-form-field>
            <mat-form-field appearance="outline" class="login-input">
              <mat-label>Enter your password</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'" id="password" required ngModel name="password" />
              <button mat-icon-button matSuffix (click)="hide = !hide">
                <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </mat-form-field>

            <p class="forget-password">Forget Password?</p>

            <button mat-raised-button color="primary" [disabled]="!loginForm.valid" id="submit">
              LOGIN
            </button>
          </form>
        </mat-card>
      </div>

      <div fxFlex.gt-xs="40"fxHide.xs>
        <img src="./assets/images/app_mockup.png" style="width: 75%;" />
      </div>
    </div>

  </div>
</div>